module.exports = __webpack_public_path__ + "static/media/dark-motion-deployment-optimisation.24be67d.mp4";